export const CallButton = ({ btnPrimary, animated, slideInLeft, children }) => {
    return (
        <a
  href="https://wa.me/353857563001"
  target="_blank"
  rel="noopener noreferrer"
  className="btn btn-primary rounded-pill py-2 px-4 call-button"
>
  Call Us For Booking 
</a>
    );
};